var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mb-4"},[_c('div',{staticClass:"col-md-12 col-lg-6"},[_c('b-notification',{attrs:{"closable":false,"role":"alert","type":"is-info is-light"}},[_vm._v(" Cette commande est terminée 👌 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }